<input
  pInputText
  id="numericRange"
  name="numericRange"
  #numericRange="ngModel"
  [(ngModel)]="displayValue"
  (ngModelChange)="handleValueChange($event)"
  [ngClass]="{
    'ng-invalid': formControl?.invalid,
    'ng-valid': formControl?.valid
  }"
  autocomplete="off"
  [class]="styleClass"
  [placeholder]="placeholder"
  [defaultValue]="defaultValue"
  (focus)="onFocus()"
  (blur)="onBlur()"
  (keydown)="onKeyDown($event)"
  (clear)="onClear()"
  [required]="required"
  [disabled]="disabled"
  [readonly]="readonly"
/>
